<template>
  <div class="end-page-wrapper">
    <dv-loading class="loading">
      <img class="bg" src="@/assets/image/bg.jpg" />
      <div class="loading-text">谢谢你的模拟面试!</div>
      <div class="start-btn">
        <img
          class="bg"
          @click="onSkipPageFn('/trainingInterview/welcome')"
          src="@/assets/image/start-btn3.png"
        />
        <img
          class="bg"
          @click="onSkipPageFn('/trainingInterview/report_list')"
          src="@/assets/image/start-btn4.png"
        />
      </div>
    </dv-loading>
  </div>
</template>

<script>
export default {
  data() {
    return {
      channel: localStorage.getItem('channel')
    }
  },
  methods: {
    // 跳转页面
    onSkipPageFn(url) {
      if (this.channel) {
        this.$router.push(`${url}?channel=${this.channel}`)
      } else {
        this.$router.push(`${url}`)
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.end-page-wrapper
  position fixed
  left 0
  top 0
  width 100%
  height 100%
  .loading
    position fixed
    left 0
    top 0
    width 100%
    height 100%
    display flex
    align-items center
    justify-content center
    z-index 999
    .bg
      position absolute
      left 0
      top 0
      width 100%
      height 100%
      display block
      z-index -1
    .loading-text
      font-weight bold
      line-height 100px
      text-align center
      font-size 30px
      opacity 0.8
      color #fff
    .start-btn
      width 100%
      height auto
      display flex
      img
        position relative
        width 200px
        height auto
        display block
        cursor pointer
        margin 0 30px
        z-index 10
</style>
